import styled from "styled-components";

export const StepContainerStyled = styled.div`
  .loading_layout {
    height: calc(100vh - 186px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .score_show_1 {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S34};
    font-family: ${({ theme }) => theme.FONT.STYLE.BOLD};
  }
  .title_layout {
    margin-bottom: 19px;
  }
  .section_introduce_layout {
    margin-bottom: 22px;
  }
  .block_4_col_layout {
    display: flex;
    padding: 10px 0px 43px 5px;
    margin-bottom: 3px;
    column-gap: 16px;
    row-gap: 16px;
    margin: 0 -5px;
    overflow: auto;
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    ::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }
    ::-webkit-scrollbar-thumb {
      background: #cccccc;
      border: 0px none #ffffff;
      border-radius: 50px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #cccccc;
    }
    ::-webkit-scrollbar-thumb:active {
      background: #c2c2c2;
    }
    ::-webkit-scrollbar-track {
      background: #ebebeb;
      border: 0px none #ffffff;
      border-radius: 50px;
    }
    ::-webkit-scrollbar-track:hover {
      background: #e6e6e6;
    }
    ::-webkit-scrollbar-track:active {
      background: #ebebeb;
    }
    ::-webkit-scrollbar-corner {
      background: transparent;
    }
    .col_4 {
      flex: 1;
      min-width: 264px;
      .wrap_mr5_overflow {
        margin-right: 5px;
      }
      .mr_22 {
        margin-right: 22px;
      }
      .icon_wrap {
        height: 92px;
      }
    }
  }
  .block_2_col_layout {
    display: flex;
    padding: 10px 0px 10px 5px;
    column-gap: 24px;
    row-gap: 24px;
    margin: 0 -5px;
    overflow: auto;
    ::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    ::-webkit-scrollbar-button {
      width: 0px;
      height: 0px;
    }
    ::-webkit-scrollbar-thumb {
      background: #cccccc;
      border: 0px none #ffffff;
      border-radius: 50px;
    }
    ::-webkit-scrollbar-thumb:hover {
      background: #cccccc;
    }
    ::-webkit-scrollbar-thumb:active {
      background: #c2c2c2;
    }
    ::-webkit-scrollbar-track {
      background: #ebebeb;
      border: 0px none #ffffff;
      border-radius: 50px;
    }
    ::-webkit-scrollbar-track:hover {
      background: #e6e6e6;
    }
    ::-webkit-scrollbar-track:active {
      background: #ebebeb;
    }
    ::-webkit-scrollbar-corner {
      background: transparent;
    }
    .col_2 {
      &.flex_1 {
        flex: 1;
      }
      &.w_388 {
        flex-shrink: 0;
        width: 388px;
      }
      &.mw_780 {
        min-width: 780px;
      }
      .wrap_mr5_overflow {
        margin-right: 5px;
      }
    }
  }
  .export {
    margin-top: 14px;
  }
`;
